import { userRoleCreate, myUserRoleRead, userRoleDelete, userRoleObserve }  from '../../services/api/userrole'

export const USER_ROLE_CREATE_REQUEST = 'USER_ROLE_CREATE_REQUEST'
export const USER_ROLE_CREATE_SUCCESS = 'USER_ROLE_CREATE_SUCCESS'
export const USER_ROLE_CREATE_FAIL = 'USER_ROLE_CREATE_FAIL'

export const USER_ROLE_READ_REQUEST = 'USER_ROLE_READ_REQUEST'
export const USER_ROLE_READ_SUCCESS = 'USER_ROLE_READ_SUCCESS'
export const USER_ROLE_READ_FAIL = 'USER_ROLE_READ_FAIL'

export const USER_ROLE_UPDATE_REQUEST = 'USER_ROLE_UPDATE_REQUEST'
export const USER_ROLE_UPDATE_SUCCESS = 'USER_ROLE_UPDATE_SUCCESS'
export const USER_ROLE_UPDATE_FAIL = 'USER_ROLE_UPDATE_FAIL'

export const USER_ROLE_DELETE_REQUEST = 'USER_ROLE_DELETE_REQUEST'
export const USER_ROLE_DELETE_SUCCESS = 'USER_ROLE_DELETE_SUCCESS'
export const USER_ROLE_DELETE_FAIL = 'USER_ROLE_DELETE_FAIL'

export function handleUserRoleCreate(user, role) {
  return dispatch => {
    dispatch({
      type: USER_ROLE_CREATE_REQUEST,
      payload: { user: user, role: role },
    })
    userRoleCreate(user, role)
    .then(data => {
      dispatch({
        type: USER_ROLE_CREATE_SUCCESS,
        payload: data,        
      })
    })
    .catch(err => {
      dispatch({
        type: USER_ROLE_CREATE_FAIL,
        error: true,
        payload: new Error(err),
      })
    })
  }
}

export function handleUserRoleRead(userId) {
  return dispatch => {
    dispatch({
      type: USER_ROLE_READ_REQUEST,
      payload: {userId : userId},
    })
    myUserRoleRead(userId)
    .then(data => {
      dispatch({
        type: USER_ROLE_READ_SUCCESS,
        payload: data,        
      })
    })
    .catch(err => {      
      dispatch({
        type: USER_ROLE_READ_FAIL,
        error: true,
        payload: new Error(err),
      })
    })
  }
}

export function handleUserRoleDelete(userRoleId) {
  return dispatch => {
    dispatch({
      type: USER_ROLE_DELETE_REQUEST,
      payload: { userRoleId: userRoleId },
    })
    userRoleDelete(userRoleId)
    .then(data => {
      dispatch({
        type: USER_ROLE_DELETE_SUCCESS,
        payload: data,
      })
    })
    .catch(err => {
      dispatch({
        type: USER_ROLE_DELETE_FAIL,
        error: true,
        payload: new Error(err),
      })
    })
  }
}

export function observeUserRole(userId) {
  return dispatch => {
    userRoleObserve(userId)
  }
}

export function handleUserRoleObserver(data) {
  return dispatch => {
    switch (data.opType) {
      case 'INSERT':
        dispatch({
          type: USER_ROLE_CREATE_SUCCESS,
          payload: data.element,
        })   
        break;
      case 'UPDATE':
        dispatch({
          type: USER_ROLE_UPDATE_SUCCESS,
          payload: data.element,
        })   
        break;
      case 'DELETE':
        dispatch({
          type: USER_ROLE_DELETE_SUCCESS,
          payload: data.element,
        })   
        break;      
      default:
        break;
    }    
  }
}

export function handleUserRoleObserverAPI(event, data) {
  return dispatch => {
    switch (event) {
      case 'INSERT':
        dispatch({
          type: USER_ROLE_CREATE_SUCCESS,
          payload: data,
        })   
        break;
      case 'UPDATE':
        dispatch({
          type: USER_ROLE_UPDATE_SUCCESS,
          payload: data,
        })   
        break;
      case 'DELETE':
        dispatch({
          type: USER_ROLE_DELETE_SUCCESS,
          payload: data,
        })   
        break;      
      default:
        break;
    }    
  }
}